import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
  Button as MuiButton,
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogContentText as MuiDialogContentText,
} from '@mui/material';

import { TextArea } from 'components/ui';

const ConfirmClosePopup = ({
  onCancel,
  onClose,
  open,
  icon,
  title,
  subTitle,
  fontSize = 126,
  hasComment = false,
  cancelButtonText = null,
  confirmButtonText = null
}) => {
  const [comment, setComment] = useState(null);
  const { t } = useTranslation();

  const handleOnClose = () => {
    onClose(comment);
  };

  return (
    <MuiDialog open={open} onClose={onCancel}>
      <SDialogContent>
        <SIconWrapper style={{ fontSize }}>{icon}</SIconWrapper>
        <MuiDialogContentText>
          <STitle>{title}</STitle>
          <SSubTitle>{subTitle}</SSubTitle>
          {/* {hasComment &&
            <TextArea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder={t('Add a note')}
              fullWidth={true}
              style={{ marginTop: 20 }}
            />
          } */}
        </MuiDialogContentText>
      </SDialogContent>
      <SDialogActions>
        <MuiButton
          type="submit"
          variant="outlined"
          onClick={onCancel}
          color="primary"
        >
          {cancelButtonText ?? t('Do not cancel')}
        </MuiButton>
        <MuiButton
          type="submit"
          variant="contained"
          onClick={handleOnClose}
          color="primary"
        >
          {confirmButtonText ?? t('Yes, I’m sure')}
        </MuiButton>
      </SDialogActions>
    </MuiDialog>
  );
};

const SDialogContent = styled(MuiDialogContent)`
  padding: 0 50px;
`;

const SIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 40px 0 30px;
`;

const STitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  color: ${({theme}) => theme.palette.colors.black100};
`;
const SSubTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin-top: 10px;
  color: ${({theme}) => theme.palette.colors.black100};
`;
const SDialogActions = styled(MuiDialogActions)`
  && {
    margin: 20px 0;
    padding: 0 50px;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }
`;

export default ConfirmClosePopup;
